<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="18" viewBox="0 0 4 18">
    <slot />
    <g :fill="color">
      <path
        d="M0 2c0 1.106.894 2 2 2 1.106 0 2-.894 2-2 0-1.106-.894-2-2-2C.894 0 0 .894 0 2zM0 9c0 1.106.894 2 2 2 1.106 0 2-.894 2-2 0-1.106-.894-2-2-2-1.106 0-2 .894-2 2zM0 16c0 1.106.894 2 2 2 1.106 0 2-.894 2-2 0-1.106-.894-2-2-2-1.106 0-2 .894-2 2z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
